var _mask, _rect, _circle, _rect2, _rect3, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoundabout4Exits2Lanes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "-100 -100 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: -100,
    y: -100,
    fill: "#FFF",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("circle", {
    x: -70,
    y: -70,
    r: 20,
    fill: "#000"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    x: -100,
    y: -100,
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    x: -70,
    y: -70,
    r: 75,
    fill: "#3a4149",
    mask: "url(#r)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 80,
    x: -100,
    y: -40,
    fill: "#3a4149",
    mask: "url(#r)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 200,
    x: -40,
    y: -100,
    fill: "#3a4149",
    mask: "url(#r)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    x: -70,
    y: -70,
    r: 45,
    fill: "none",
    stroke: "#FFF",
    strokeDasharray: "5 7",
    strokeWidth: 1,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M -100 -20     L -70 -20     M 100 -20     L 70 -20     M -20 100     L -20 70     M -20 -100     L -20 -70     M -100 20     L -70 20     M 100 20     L 70 20     M 20 100     L 20 70     M 20 -100     L 20 -70",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeDasharray: "6 5",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "     M -100 0     L -70 0     M 100 0     L 70 0     M 0 100     L 0 70     M 0 -100     L 0 -70",
    stroke: "#FFF",
    strokeWidth: 1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundabout4Exits2Lanes);
export default __webpack_public_path__ + "static/media/roundabout-4-exits-2-lanes.d2b54faac3864ddd1f9cece48ae2db8a.svg";
export { ForwardRef as ReactComponent };